import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { ControlledCheckboxNew } from '@Components/inputs/ControlledInputs';
import { COUNTRY_OPTIONS, NONE_FIELD, NONE_VALUE } from './hooks/useSanctionedCountriesLogic';

export const SanctionedCountriesForm = () => {
  const { t } = useTranslation('eddQuestions');
  const { control, setValue } = useFormContext();

  return (
    <div className='flex flex-col gap-4'>
      {COUNTRY_OPTIONS.map((option) => (
        <ControlledCheckboxNew
          key={option.value}
          control={control}
          name={option.field}
          id={option.value}
          props={{
            label: t(`organic.sanctionedCountries.${option.value}`),
            labelTextColor: 'text-surface-primary-bw-07',
          }}
          handleOnChange={(isChecked) => {
            if (isChecked) setValue(NONE_FIELD, false);
          }}
        />
      ))}
      <ControlledCheckboxNew
        control={control}
        name={NONE_FIELD}
        id={NONE_VALUE}
        props={{
          label: t('organic.sanctionedCountries.none'),
          labelTextColor: 'text-surface-primary-bw-07',
        }}
        handleOnChange={(isChecked) => {
          if (isChecked) {
            COUNTRY_OPTIONS.forEach((o) => setValue(o.field, false));
          }
        }}
      />
    </div>
  );
};
